const React = require('react');
const PropTypes = require('prop-types');
const DonutChart = require('components/charts/DonutChart/DonutChart');
const stocksSectorHelper = require('utilities/stocksSectorHelper');
const { formatValue } = require('../utilities/valueFormater');

const GlobalStockChart = ({ colors, data, activeIndex, textWidth }) => (
    <DonutChart
        activeIndex={activeIndex}
        colors={colors}
        data={data}
        dataKey="value"
        height={400}
        textWidth={textWidth}
        titles={{
            type: t => stocksSectorHelper(t),
            value: v => `${formatValue(v)}%`,
        }}
        width={'100%'}
    />
);

GlobalStockChart.propTypes = {
    activeIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    colors: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    textWidth: PropTypes.string,
};

module.exports = GlobalStockChart;
